/**
 * Извлекает сообщение об ошибке из ответа API или возвращает fallback.
 */
export function getApiErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  return fallback;
}
